import { add, listen, qs, qsa, remove, toggle } from '@fluorescent/dom';
import { get, set } from '@fluorescent/storage';
import { slideDown, slideUp, slideStop, isVisible } from 'slide-anim';
import { on } from '@/neon/events';

import priceRange from '@/lib/collection/price-range';

import { updateFilters } from '@/lib/collection/events';

const classes = {
  active: 'active',
  closed: 'closed',
};

const ls = {
  getClosed: () => get('closed_sidebar_groups') || [],
  setClosed: val => set('closed_sidebar_groups', JSON.stringify(val)),
};

const sel = {
  heading: '[data-heading]',
  tag: '[data-tag]',
  filterItemLabel: '[data-filter-item-label]',
  sort: '[data-sort]',
  priceRange: '[data-price-range]',
  sidebarForm: '[data-filer-sidebar-form]',
  getGroup: group => `[data-group="${group}"]`,
};

export default node => {
  if (!node) return Function();
  const sidebarForm = qs(sel.sidebarForm, node);

  const click = listen(node, 'click', handleClick);
  const change = listen(node, 'change', handleChange);

  let range = null;
  let rangeContainer = qs(sel.priceRange, sidebarForm);

  if (rangeContainer) {
    range = priceRange(rangeContainer);
  }

  let collectionUpdatedHanlder = on('collection:updated', collectionUpdated);

  function collectionUpdated(evt) {
    const updatedFilterItems = qsa(`${sel.sidebarForm} ${sel.filterItemLabel}`, evt.doc);

    updatedFilterItems.forEach(element => {
      updateInnerHTML(`${sel.sidebarForm} ${sel.filterItemLabel}[for="${element.getAttribute('for')}"]`, evt.doc);
    });
  }

  function updateInnerHTML(selector, doc) {
    const updatedItem = qs(selector, doc);
    const oldItem = qs(selector, sidebarForm);
    if (updatedItem && oldItem) {
      oldItem.innerHTML = updatedItem.innerHTML;
      oldItem.className = updatedItem.className;
    }
  }

  function handleChange(evt) {
    const { sort, filter, rangeInput } = evt.target.dataset;

    if (rangeInput || sort || filter) {
      updateFilters(sidebarForm);
    }
  }

  function handleClick(evt) {
    // evt.preventDefault();

    const { heading } = evt.target.dataset;

    if (heading) {
      evt.preventDefault();
      const { nextElementSibling: content } = evt.target;
      slideStop(content);

      const current = ls.getClosed();
      if (isVisible(content)) {
        add(evt.target, classes.closed);
        slideUp(content);
        ls.setClosed([...current, heading]);
      } else {
        remove(evt.target, classes.closed);

        const slideOptions = {
          display: 'block',
        };

        if (
          content.classList.contains('filter-drawer__list--swatch') ||
          content.classList.contains('filter-drawer__list--chip')
        ) {
          slideOptions.display = 'flex';
        }

        slideDown(content, slideOptions);
        ls.setClosed(current.filter(item => item !== heading));
      }
    }
  }

  function removeRange() {
    range && range.reset();
  }

  function unload() {
    click();
    change();
    range && range.unload();
    collectionUpdatedHanlder();
  }

  return () => {
    unload();
  };
};
